import { Link } from 'react-router-dom'
import { LUGroupIcon } from './icons/LUGroupIcon'
import { data } from 'data/footerData'

interface LUGroupProps { }

export const LUGroup = ({ }: LUGroupProps) => {
  return (
    <div className='pb-40 relative rounded-bl-[30px] inline-flex flex-col justify-start items-end gap-14'>
      <div className='px-20 pt-14 pb-40 w-[90%] sm:w-[80%] ml-auto bg-[#001a3d] rounded-tl-[30px] rounded-bl-[30px] shadow-[4px_4px_200px_0px_rgba(0,0,0,0.50)] inline-flex flex-col justify-start items-start gap-14'>
        <div className='transform scale-50 sm:scale-100 origin-left'>
          <LUGroupIcon />
        </div>
        <div className='self-stretch flex flex-col justify-center items-start gap-14'>
          <div className='self-stretch flex flex-col justify-start items-start gap-5'>
            <div className='self-stretch opacity-80 justify-center'>
              <span className="text-white sm:text-3xl text-lg font-bold font-['DM_Sans']">
                Getting legal professions to work for everyone. <br />
              </span>
              <span className="text-white sm:text-2xl text-lg font-normal font-['DM_Sans'] leading-loose tracking-wide">
                <br />
                We use technology and data to help people make better decisions
                about legal services.
                <br />
                <br />
                We do this by understanding people’s legal needs, leveraging
                data to match them with the right lawyer, and through technical
                and data architecture that provides unique insight into the
                legal professions.
              </span>
            </div>
          </div>
          <Link
            to={data[1][2].subs[0][0].url}
            className='bg-white !px-3 py-2 text-cyan-700 font-medium rounded-lg'
          >
            Learn more
          </Link>
        </div>
        <div className='p-10 absolute bottom-12 right-12 bg-teal-500 rounded-[20px] outline outline-2 outline-offset-[-2px] outline-white/10 flex flex-col justify-start items-start gap-6'>
          <div className="self-stretch justify-start text-slate-900 sm:text-3xl text-lg font-bold font-['DM_Sans']">
            Get it done.
            <br />
            <br />
            Be data curious.
            <br />
            <br />
            Seek clarity.
          </div>
        </div>
      </div>
    </div>
  )
}
